var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompassNeedleLight = function SvgCompassNeedleLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F15D4F",
    d: "m8.364 11.784 3.122-9.91a.29.29 0 0 1 .554.002l3.063 9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.098 11.775-3.122 9.909a.29.29 0 0 1-.554-.002l-3.063-9.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.765,
    cy: 12.175,
    r: 1.16,
    fill: "currentColor",
    transform: "rotate(45 11.765 12.175)"
  })));
};
export default SvgCompassNeedleLight;